var shopifyHeader = document.querySelector('[data-header]');
var shopifyHeaderHeight = shopifyHeader ? shopifyHeader.offsetHeight : 0;

var sectionAnnouncement = document.querySelector('#shopify-section-announcement-bar');
var announcementHeight = sectionAnnouncement ? sectionAnnouncement.offsetHeight : 0;

document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
document.documentElement.style.setProperty(
	'--header-height',
	shopifyHeaderHeight + announcementHeight + 'px',
);

document.documentElement.style.setProperty('--collection-nav-position', shopifyHeaderHeight + 'px');
document.documentElement.style.setProperty('--banner-bundle-position', shopifyHeaderHeight + 'px');

var headerTransparent = document.querySelector('.header--transparent');
if (headerTransparent != undefined) var isIndex = true;
else var isIndex = false;

// Open / Close mobile sidemenu eventlistener
var headerHamburger = document.querySelector('[data-header-hamburger]');
var headerCross = document.querySelector('[data-header-cross]');
var headerSidemenu = document.querySelector('[data-header-sidemenu]');
var headerSidemenuBackground = document.querySelector('[data-header-sidemenu-background]');
if (headerHamburger != undefined) {
	headerHamburger.addEventListener('click', () => {
		openSidemenu();
	});
}
if (headerCross != undefined) {
	headerCross.addEventListener('click', () => {
		closeSidemenu();
	});
}
if (headerSidemenuBackground != undefined) {
	headerSidemenuBackground.addEventListener('click', () => {
		closeSidemenu();
	});
}
// Open / Close mobile sidemenu function
function openSidemenu() {
	if (headerSidemenuBackground != undefined) headerSidemenuBackground.classList.remove('hide');
	if (headerSidemenu != undefined) {
		headerSidemenu.classList.remove('hide');
		setTimeout(() => {
			headerSidemenu.classList.add('header--sidemenu-open');
		}, 100);
		var dataEvent = {
			popin_status: 'opened',
		};
		var evt = new CustomEvent('gtmClickBurgerMenu', { detail: dataEvent });
		window.dispatchEvent(evt);
		var dataEvent = {};
		var evt = new CustomEvent('gtmPopinBurgerMenu', { detail: dataEvent });
		window.dispatchEvent(evt);
	}
}
function closeSidemenu() {
	if (headerSidemenu != undefined) {
		headerSidemenu.classList.remove('header--sidemenu-open');
		if (headerSidemenuBackground != undefined) headerSidemenuBackground.classList.add('hide');
		setTimeout(() => {
			headerSidemenu.classList.add('hide');
		}, 600);

		var dataEvent = {
			popin_status: 'closed',
		};
		var evt = new CustomEvent('gtmClickBurgerMenu', { detail: dataEvent });
		window.dispatchEvent(evt);
	}
}

// Accordion mobile menus
var sideMenuTitle = document.querySelectorAll('[data-sidemenu-title]');
sideMenuTitle.forEach((title) => {
	title.addEventListener('click', (event) => {
		event.target.nextElementSibling.classList.toggle('content-transition');
	});
});

// Show / Hide header logo mobile on scroll
var logoMobileTop = document.querySelector('.header__logo-mobile--top');
var logoMobileScroll = document.querySelector('.header__logo-mobile--scroll');
var lastScrollTopPosition = 0;

// Ajouter les éléments de navigation de collection
var collectionNavSticky = document.querySelector("[data-collection-nav]");
var collectionNavStatic = document.querySelector("[data-collection-nav-static]");

window.addEventListener('scroll', function () {
	var scrollTop = document.documentElement.scrollTop;

	document.documentElement.style.setProperty(
		'--banner-bundle-position',
		shopifyHeader.offsetHeight + 'px',
	);
	positionPackContainerMobile();

	// Gérer la visibilité du nav de collection
	if (collectionNavSticky && collectionNavStatic) {
		const staticRect = collectionNavStatic.getBoundingClientRect();
		// Si l'élément statique est visible dans la fenêtre
		if (staticRect.top >= 0 && staticRect.bottom <= window.innerHeight) {
			collectionNavSticky.classList.remove('active');
		} else {
			// Ne pas afficher le sticky jusqu'à ce qu'on ait dépassé l'élément statique
			if (staticRect.bottom < 0) {
				collectionNavSticky.classList.add('active');
			} else {
				collectionNavSticky.classList.remove('active');
			}
		}
	}

	if (logoMobileTop != undefined && logoMobileScroll != undefined) {
		if (scrollTop > 100) {
			if (logoMobileScroll.classList.contains('hide')) {
				logoMobileTop.classList.add('hide');
				logoMobileScroll.classList.remove('hide');
				document.querySelector('.header--mobile .header__logo-container').style.height = '37px';
				if (isIndex && shopifyHeader.classList.contains('header--transparent'))
					shopifyHeader.classList.remove('header--transparent');

				// update collection nav position
				if (collectionNavSticky) {
					setTimeout(() => {
						shopifyHeaderHeight = shopifyHeader.offsetHeight;
						document.documentElement.style.setProperty(
							'--collection-nav-position',
							shopifyHeaderHeight + 'px',
						);
						// Ne pas ajouter active ici, maintenant géré séparément
					}, 500);
				}
			}
		} else if (scrollTop < 50) {
			if (logoMobileTop.classList.contains('hide')) {
				logoMobileScroll.classList.add('hide');
				logoMobileTop.classList.remove('hide');
				document.querySelector('.header--mobile .header__logo-container').style.height = '70px';
				if (isIndex && !shopifyHeader.classList.contains('header--transparent'))
					shopifyHeader.classList.add('header--transparent');

				// update collection nav position
				if (collectionNavSticky) {
					collectionNavSticky.classList.remove('active');
				}
			}
		}
		lastScrollTopPosition = scrollTop;
	}
});

// Show / Hide search bar
var searchButtons = document.querySelectorAll('[data-header-search-button]');
var searchBars = document.querySelectorAll('[data-header-search]');
var searchClose = document.querySelectorAll('[data-header-search-close]');

// Show search bar
searchButtons.forEach((button) => {
	var buttonData = button.dataset.headerSearchButton;
	button.addEventListener('click', () => {
		document.querySelectorAll('[data-header-search]').forEach((bar) => {
			if (bar.dataset.headerSearch == buttonData) {
				bar.classList.add('active');
				bar.querySelector('input').focus();
			}
		});
	});
});
// Hide search bar
searchClose.forEach((close) => {
	var closeData = close.dataset.headerSearchClose;
	close.addEventListener('click', () => {
		document.querySelectorAll('[data-header-search]').forEach((bar) => {
			if (bar.dataset.headerSearch == closeData) {
				bar.classList.remove('active');
			}
		});
	});
});

// PACK BUNDLE
positionPackContainerMobile();

function positionPackContainerMobile() {
	var bannerPackBundleHeight = document.querySelector('[data-banner-pack-bundle]');
	if (bannerPackBundleHeight != undefined) {
		bannerPackBundleHeight = bannerPackBundleHeight.offsetHeight;
		var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
		if (viewportWidth <= 1024) {
			document.documentElement.style.setProperty(
				'--banner-bundle-position-mobile',
				bannerPackBundleHeight + 'px',
			);
		}

		window.addEventListener(
			'resize',
			function () {
				viewportWidth = window.innerWidth || document.documentElement.clientWidth;
				if (viewportWidth <= 1024) {
					document.documentElement.style.setProperty(
						'--banner-bundle-position-mobile',
						bannerPackBundleHeight + 'px',
					);
				}
			},
			false,
		);
	}
}

// Languages selector

var selectedLanguage = document.querySelectorAll('.header--mobile__selected-language');
selectedLanguage.forEach((sl) => {
	sl.addEventListener('click', (el) => {
		var container = el.target.closest('.header--mobile__languages-selector');
		var languages = container.querySelector('.header--mobile__languages');
		languages.classList.toggle('active');
	});
});